import React from 'react';
import {
    EQUIPO_EXPEDIENTE_FIELDS,
    INSTALACION_EXPEDIENTE_FIELDS,
    PERSONAL_EXPEDIENTE_FIELDS,
} from '../../constants/centro.constants';
import { CentroFormData, ExpedienteCentro } from '../../types/centro.types';

interface TabExpedienteProps {
    formData: CentroFormData;
    onExpedienteChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const formatFieldLabel = (field: string) => field.split('_').slice(1).join(' ');

const CheckboxGroup: React.FC<{
    fields: readonly string[];
    expediente: ExpedienteCentro;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}> = ({ fields, expediente, onChange }) => (
    <div className="row g-3">
        {fields.map((f) => (
            <div className="col-sm-6" key={f}>
                <div className="form-check form-switch">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        id={f}
                        name={f}
                        checked={Boolean(expediente[f as keyof ExpedienteCentro])}
                        onChange={onChange}
                    />
                    <label className="form-check-label text-capitalize small" htmlFor={f}>
                        {formatFieldLabel(f)}
                    </label>
                </div>
            </div>
        ))}
    </div>
);

export const TabExpediente: React.FC<TabExpedienteProps> = ({ formData, onExpedienteChange }) => (
    <div className="row g-4">
        <div className="col-lg-6">
            <div id="centro-expediente-personal" className="card border-0 shadow-sm mb-4">
                <div className="card-header fw-bold">
                    <i className="fas fa-users me-2" />Personal Operativo
                </div>
                <div className="card-body">
                    <CheckboxGroup
                        fields={PERSONAL_EXPEDIENTE_FIELDS}
                        expediente={formData.expediente}
                        onChange={onExpedienteChange}
                    />
                </div>
            </div>
            <div id="centro-expediente-operacion" className="card border-0 shadow-sm">
                <div className="card-header fw-bold">
                    <i className="fas fa-tasks me-2" />Operación
                </div>
                <div className="card-body">
                    <div className="form-check form-switch">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            id="salida_mismo_dia"
                            name="salida_mismo_dia"
                            checked={formData.expediente.salida_mismo_dia}
                            onChange={onExpedienteChange}
                        />
                        <label className="form-check-label fw-bold" htmlFor="salida_mismo_dia">
                            Salida mismo día
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <div className="col-lg-6">
            <div id="centro-expediente-infraestructura" className="card border-0 shadow-sm mb-4">
                <div className="card-header fw-bold">
                    <i className="fas fa-warehouse me-2" />Infraestructura
                </div>
                <div className="card-body">
                    <div className="row g-2 mb-3 pb-3 border-bottom">
                        <div className="col-6">
                            <label className="small fw-bold">Rampas</label>
                            <input
                                type="number"
                                className="form-control form-control-sm"
                                name="instalacion_rampas_servicio"
                                value={formData.expediente.instalacion_rampas_servicio}
                                onChange={onExpedienteChange}
                            />
                        </div>
                        <div className="col-6">
                            <label className="small fw-bold">Sitios Productivos</label>
                            <input
                                type="number"
                                className="form-control form-control-sm"
                                name="instalacion_sitios_productivos"
                                value={formData.expediente.instalacion_sitios_productivos}
                                onChange={onExpedienteChange}
                            />
                        </div>
                        <div className="col-12 mt-2">
                            <label className="small fw-bold">Horario Grúa</label>
                            <input
                                type="text"
                                className="form-control form-control-sm"
                                name="horario_recepcion_grua"
                                value={formData.expediente.horario_recepcion_grua}
                                onChange={onExpedienteChange}
                                placeholder="Ej. L-V 09:00 a 14:00"
                            />
                        </div>
                    </div>
                    <CheckboxGroup
                        fields={INSTALACION_EXPEDIENTE_FIELDS}
                        expediente={formData.expediente}
                        onChange={onExpedienteChange}
                    />
                </div>
            </div>
            <div id="centro-expediente-equipo" className="card border-0 shadow-sm">
                <div className="card-header fw-bold">
                    <i className="fas fa-toolbox me-2" />Equipo Especializado
                </div>
                <div className="card-body">
                    <CheckboxGroup
                        fields={EQUIPO_EXPEDIENTE_FIELDS}
                        expediente={formData.expediente}
                        onChange={onExpedienteChange}
                    />
                </div>
            </div>
        </div>
    </div>
);
